import { useEffect, useRef } from 'react';
import { useTaskStore } from '@/stores/taskStore';
import { LIVE_DEBOUNCE_MS } from './useTasks';

/**
 * SF-T-153: calls `reload` (debounced) each time the live task hub says task `taskId` changed, while
 * `enabled`, and after a reconnect that may have missed one. Not on mount: the caller has just loaded. For a dialog whose loader doesn't follow the
 * task's version (data-freshness.project.mdc).
 */
export function useTaskLiveReload(taskId: string, enabled: boolean, reload: () => unknown): void {
  // A reconnect's resync only bumps tasks already in taskTicks, so it's followed on its own too.
  const tick = useTaskStore((s) => `${s.resyncTick}.${s.taskTicks[taskId] ?? 0}`);
  const firstTick = useRef(tick);
  const latest = useRef(reload);
  useEffect(() => {
    latest.current = reload;
  });
  useEffect(() => {
    if (!enabled || tick === firstTick.current) return undefined;
    const timer = setTimeout(() => void latest.current(), LIVE_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [tick, enabled]);
}
